import React from 'react';
import { Box } from '@mui/material';
import LogoSVG from './LogoSVG';

function Logo({ variant = 'default', size = 'medium', showText = true }) {
  const sizes = {
    small: { width: 150, height: 45 },
    medium: { width: 200, height: 60 },
    large: { width: 250, height: 75 }
  };

  const { width, height } = sizes[size];

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <LogoSVG width={width} height={height} iconOnly={!showText} />
    </Box>
  );
}

export default Logo;
